module.exports = __webpack_public_path__ + "img/t12.125a5113.png";